<template>
  <v-container fluid>
    <!-- Input -->
    <form autocomplete="off">
      <v-row>
        <v-col>
          <v-text-field class="ml-4 mr-4 mb-4" dense hide-details label="Codice Servizio" v-model="selected_item.codice" readonly></v-text-field>
        </v-col>
        
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="3">
          <!--<v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  ref="form_rag_soc"
                  v-bind="attrs"
                  v-on="on"
                  @change="selezionaAzienda"
                  label="Ragione Sociale"
                  v-model.number="selected_item.id_azienda"
                  dense
                  hide-details
                  :items="items_azienda"
                  item-text="ragione_sociale"
                  item-value="id_anagrafica"
                />
              </template>
<span>Digita almeno 3 caratteri per la ricerca</span>
</v-tooltip>-->

          <!-- Ragione sociale -->
          <!-- @blur="resetArticolo('A')" 
                          @focus="
                  last_rag_soc_anagrafica = JSON.parse(
                    JSON.stringify(documento.ragione_sociale)
                  );
                "-->
          <v-text-field dense required hide-details label="Ragione sociale" v-model="search_azienda"
            @blur="search_azienda = selected_azienda.ragione_sociale"
            @keyup.enter.native="goToAnagrafica(search_azienda, '', '')">
            <template v-slot:append>
              <v-icon class="ml-2" @click="goToAnagrafica(search_azienda, '', '')" color="primary">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-autocomplete :readonly="selected_item.id_azienda && !azienda_sedi" @change="aggiornaCampi" @click="
            !selected_item.id_azienda
              ? message('Selezionare ragione sociale')
              : !azienda_sedi
                ? message('Nessuna sede trovata')
                : ''
            " label="Indirizzo sede / cantiere" v-model.number="selected_item.id_sede_arrivo" dense hide-details
            :items="azienda_sedi" :item-text="(e) => {
                return e.citta + ' - ' + e.indirizzo;
              }
              " item-value="id_anagrafica_sede">
            <template #label>
              <span> Indirizzo sede / cantiere </span>
              <a @click.stop="getAllineaSedi(false)" style="pointer-events: all">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="primary">mdi-sync</v-icon>
                  </template>
                  <span>Allinea sedi</span>
                </v-tooltip>
              </a>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="search_piva" label="P.Iva/Cod.Fiscale" dense hide-details
            @blur="search_piva = selected_azienda.piva" @keyup.enter.native="goToAnagrafica('', search_piva, '')">
            <template v-slot:append>
              <v-icon class="ml-2" @click="goToAnagrafica('', search_piva, '')" color="primary">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="search_cod_univoco" label="Cod.Cliente" dense hide-details
            @blur="search_cod_univoco = selected_azienda.codice_univoco" @keyup.enter.native="
              is_cod_search = true;
            goToAnagrafica('', '', search_cod_univoco);
            ">
            <template v-slot:append>
              <v-icon class="ml-2" @click="
                is_cod_search = true;
              goToAnagrafica('', '', search_cod_univoco);
              " color="primary">mdi-magnify</v-icon>
            </template>

            <template #label>
              <span> Cod. Cliente </span>
              <a @click.stop="getAllineaAnagrafica(search_cod_univoco)" style="pointer-events: all">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="primary">mdi-sync</v-icon>
                  </template>
                  <span>Allinea cliente</span>
                </v-tooltip>
              </a>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-autocomplete v-model.number="selected_item.id_zona" label="Zona" dense :items="items_zona" hide-details
            item-text="des" item-value="id_tabella">
            <template #label>
              <span>Zona<strong>* </strong></span>
              <a @click.stop style="pointer-events: all">
                <Modules v-on:dialogModules="aggiornaItemsAutocomplete" tipo="EG_ZONA" nome="Zona"
                  setaction="settabelle" getaction="gettabelle" controller="Magazzino" filter="validita = 1"
                  :dati="[{ des: '' }]" />
              </a>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-text-field type="date" dense hide-details label="Data Inizio Servizio" @change="cambioData()"
            v-model="selected_item.data_inizio" />
        </v-col>
        <v-col cols="3">
          <v-text-field type="date" dense hide-details label="Data Fine Servizio" v-model="selected_item.data_fine" @change="controlloData()"/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="selected_item.id_fascia_oraria" label="Fascia" dense :items="items_fascia"
            hide-details item-text="descrizione" item-value="id_fascia_oraria">
          </v-autocomplete>
        </v-col>
        <v-col cols="1">
          <v-text-field v-model="selected_item.ora_inizio" type="time" dense label="Ora Inizio" hide-details />
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="selected_item.orario_preferibile" type="time" dense label="Orario preferibile" hide-details />
        </v-col>
        <!-- <v-col cols="2">
          <v-text-field v-model="selected_item.ora_fine" type="time" dense label="Ora Fine" hide-details />
        </v-col> -->
        <v-col cols="2">
          <v-text-field v-model.number="selected_item.tempo_setup_partenza" label="Setup partenza" type="number" dense
            hide-details />
        </v-col>
        <v-col cols="2">
          <v-text-field v-model.number="selected_item.tempo_setup_arrivo" label="Setup arrivo" dense :maxlength="10"
            type="number" hide-details />
        </v-col>
       
        <v-col cols="2">
          <v-checkbox dense hide-details label="Attesa Carico" v-model.number="selected_item.attesa_carico" @click="
            selected_item.attesa_carico_um =
            selected_item.attesa_carico == 1
              ? items_attesa_carico_um.find((e) => e.id_tabella == 424)
                .id_tabella
              : null; selected_item.attesa_carico_valore = 30;
            " :true-value="1" :false-value="0" />
        </v-col>
        <v-col cols="1" class="px-0">
          <v-text-field :disabled="selected_item.attesa_carico == false"
            v-model.number="selected_item.attesa_carico_valore" label="Durata Attesa" type="number" dense
            hide-details />
        </v-col>
        <v-col cols="2">
          <v-autocomplete :disabled="selected_item.attesa_carico == false"
            v-model.number="selected_item.attesa_carico_um" :items="items_attesa_carico_um" label="UM Attesa" dense
            hide-details item-text="des" item-value="id_tabella" />
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="selected_item.id_dashboard" label="Dashboard Graph" item-value="id_elemento"
            item-text="descrizione" dense :items="dashboards" hide-details />
        </v-col>
        <v-col cols="4">
          <v-text-field v-model="selected_item.riferimento" label="Riferimento" dense hide-details />
        </v-col>
        <v-col cols="4">
          <!--<v-autocomplete
              v-model="selected_item.id_referente"
              label="Referente"
              dense
              hide-details
            />-->
          <v-text-field v-model="selected_item.referente" label="Referente" dense hide-details />
        </v-col>
        <v-col cols="4">
          <v-text-field v-model="selected_item.cellulare" label="Cell" dense type="number" hide-details />
        </v-col>
      </v-row>

      <v-row justify="center" class="ma-1">
        <v-col cols="3">
          <v-text-field v-model="selected_item.localita_partenza" prepend-icon="mdi-truck-fast" label="Comune Partenza"
            dense hide-details />
        </v-col>
        <v-col cols="1">
          <v-text-field @input="
            selected_item.provincia_partenza =
            selected_item.provincia_partenza.toUpperCase()
            " :maxlength="4" v-model="selected_item.provincia_partenza" label="Provincia" dense hide-details />
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="selected_item.indirizzo_partenza" label="Indirizzo" dense hide-details />
        </v-col>
        <v-col cols="1">
          <v-text-field v-model.number="selected_item.civico_partenza" label="N°" type="number" dense hide-details />
        </v-col>
        <v-col cols="1" class="pr-0">
          <v-text-field v-model.number="selected_item.cap_partenza" :maxlength="5" type="number" label="CAP" dense
            hide-details />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="selected_item.localita_arrivo" prepend-icon="mdi-bullseye-arrow" label="Comune Arrivo"
            dense hide-details />
        </v-col>
        <v-col cols="1">
          <v-text-field @input="
            selected_item.provincia_arrivo =
            selected_item.provincia_arrivo.toUpperCase()
            " :maxlength="4" v-model="selected_item.provincia_arrivo" label="Provincia" dense hide-details />
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="selected_item.indirizzo_arrivo" label="Indirizzo" dense hide-details />
        </v-col>
        <v-col cols="1">
          <v-text-field v-model.number="selected_item.civico_arrivo" label="N°" type="number" dense hide-details />
        </v-col>
        <v-col cols="1" class="pr-0">
          <v-text-field v-model.number="selected_item.cap_arrivo" label="CAP" :maxlength="5" type="number" dense
            hide-details />
        </v-col>
      </v-row>
      <v-card>
        <v-row style="cursor: pointer" @click="is_dest_senza_deposito = !is_dest_senza_deposito" class="ma-2 ml-5 mb-5">
          <v-icon color="#00000099">
            {{ is_dest_senza_deposito ? "mdi-menu-right" : "mdi-menu-down" }}
          </v-icon>
          <div style="color: #00000099; user-select: none; padding: 7px;">
            Destinatario senza deposito
          </div>
        </v-row>
        <v-row v-show="is_dest_senza_deposito" justify="center" class="ma-1">
          <v-col cols="4">
            <v-text-field dense required hide-details label="Ragione sociale" v-model="search_azienda_dest" @blur="
              search_azienda_dest = selected_azienda_dest.ragione_sociale
              " @keyup.enter.native="
                  goToAnagraficaDest(search_azienda_dest, '', '')
                  ">
              <template v-slot:append>
                <v-icon class="ml-2" @click="goToAnagraficaDest(search_azienda_dest, '', '')"
                  color="primary">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="5">
            <v-autocomplete :readonly="selected_item.id_azienda_dest && !azienda_sedi_dest" @change="aggiornaCampiDest"
              @click="
                !selected_item.id_azienda_dest
                  ? message('Selezionare ragione sociale')
                  : !azienda_sedi_dest
                    ? message('Nessuna sede trovata')
                    : ''
                " label="Indirizzo sede / cantiere" v-model.number="selected_item.id_sede_dest_senza_deposito" dense
              hide-details :items="azienda_sedi_dest" :item-text="(e) => {
                  return e.citta + ' - ' + e.indirizzo;
                }
                " item-value="id_anagrafica_sede">
              <template #label>
                <span> Indirizzo sede / cantiere </span>
                <a @click.stop="getAllineaSedi(true)" style="pointer-events: all">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="primary">mdi-sync</v-icon>
                    </template>
                    <span>Allinea sedi</span>
                  </v-tooltip>
                </a>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="search_piva_dest" label="P.Iva/Cod.Fiscale" dense hide-details
              @blur="search_piva_dest = selected_azienda_dest.piva"
              @keyup.enter.native="goToAnagraficaDest('', search_piva_dest, '')">
              <template v-slot:append>
                <v-icon class="ml-2" @click="goToAnagraficaDest('', search_piva_dest, '')"
                  color="primary">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="search_cod_univoco_dest" label="Cod.Cliente" dense hide-details @blur="
              search_cod_univoco_dest = selected_azienda_dest.codice_univoco
              " @keyup.enter.native="
                  is_cod_search_dest = true;
                goToAnagraficaDest('', '', search_cod_univoco_dest);
                ">
              <template v-slot:append>
                <v-icon class="ml-2" @click="
                  is_cod_search_dest = true;
                goToAnagraficaDest('', '', search_cod_univoco_dest);
                " color="primary">mdi-magnify</v-icon>
              </template>

              <template #label>
                <span> Cod. Cliente </span>
                <a @click.stop="getAllineaAnagrafica(search_cod_univoco_dest)" style="pointer-events: all">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="primary">mdi-sync</v-icon>
                    </template>
                    <span>Allinea cliente</span>
                  </v-tooltip>
                </a>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="selected_item.localita_dest_senza_deposito" prepend-icon="mdi-crosshairs-gps"
              label="Comune Destinatario senza deposito" dense hide-details />
          </v-col>
          <v-col cols="1">
            <v-text-field @input="
              selected_item.provincia_dest_senza_deposito =
              selected_item.provincia_dest_senza_deposito.toUpperCase()
              " :maxlength="4" v-model="selected_item.provincia_dest_senza_deposito" label="Provincia" dense
              hide-details />
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="selected_item.indirizzo_dest_senza_deposito" label="Indirizzo" dense hide-details />
          </v-col>
          <v-col cols="1">
            <v-text-field v-model.number="selected_item.civico_dest_senza_deposito" label="N°" type="number" dense
              hide-details />
          </v-col>
          <v-col cols="1" class="pr-0">
            <v-text-field v-model.number="selected_item.cap_dest_senza_deposito" label="CAP" :maxlength="5"
              type="number" dense hide-details />
          </v-col>
        </v-row>
      </v-card>

      <v-row justify="center" class="ma-1">
        <v-col cols="2">
          <v-text-field v-model.number="selected_item.distanza" label="Distanza(km)" type="number" dense hide-details />
        </v-col>
        <v-col cols="2">
          <v-text-field v-model.number="selected_item.tempo_percorrenza" label="Durata(minuti)" type="number" dense
            hide-details />
        </v-col>
        <v-col cols="2">
          <v-checkbox dense hide-details :true-value="1" :false-value="0" label="Giorni festivi"
            v-model.number="selected_item.festivo_compreso" />
        </v-col>
        <v-col cols="2">
          <v-checkbox dense hide-details :true-value="1" :false-value="0" label="Sabato"
            v-model.number="selected_item.sabato_compreso" />
        </v-col>
        <v-col cols="2">
          <v-checkbox dense hide-details :true-value="1" :false-value="0" label="Domenica"
            v-model.number="selected_item.domenica_compreso" />
        </v-col>
        <v-col cols="1" class="py-4 d-flex justify-center align-center">
          <!-- Colonna della scelta colore -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small @click="
                swatchesDefault();
              mostra_colori_sel = mostra_colori_sel == true ? false : true;
              " v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-palette </v-icon>
              </v-btn>
            </template>
            <span>Colori pianificazione</span>
          </v-tooltip>
        </v-col>
        <!-- <v-col cols="4">
          <v-autocomplete dense v-model.number="selected_item.id_tipo_formulario" label="Tipo formulario"
            :items="items_tipo_formulario" hide-details item-text="des" item-value="val_int" @change="aggiornaItemsAutocomplete();
            items_causale_formulario = [];
            selected_item.id_causale_formulario = null;" />
        </v-col>
        <v-col cols="4">
          <v-autocomplete dense v-model.number="selected_item.id_causale_formulario" label="Causale formulario"
            :items="items_causale_formulario" hide-details item-text="des" item-value="id_tabella" />
        </v-col> -->
        <!-- <v-col cols="6">
          <v-textarea v-model="selected_item.descrizione" rows="1" label="Note" dense hide-details />
        </v-col> -->
      </v-row>
    </form>
    <!-- Dialog colori pianificazione -->
    <v-dialog class="mt-5" max-width="270px" v-model="mostra_colori_sel">
      <v-card elevation="0">
        <p>Sfondo</p>
        <v-color-picker v-model="selected_item.colore_sfondo.hex" v-show="mostra_colori_sel" class="ma-2"
          swatches-max-height="80px" dark hide-canvas hide-inputs hide-sliders hide-mode-switch :swatches="swatches"
          show-swatches></v-color-picker>
        <p>Testo</p>
        <v-color-picker v-model="selected_item.colore_testo.hex" v-show="mostra_colori_sel" class="ma-2" hide-canvas
          dark hide-inputs hide-sliders hide-mode-switch :swatches="swatches_text" show-swatches></v-color-picker>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- DIALOG RICERCA RAGIONE SOCIALE -->
    <v-dialog v-model="dialog_search_aziende" width="50%" persistent>
      <v-card>
        <v-toolbar color="indigo" dense dark>
          <v-toolbar-title>Seleziona Ragione Sociale</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_search_aziende = false" light small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table :headers="headers_azienda" :items="items_azienda">
                  <template v-slot:[`item.seleziona`]="{ item }">
                    <v-btn small @click="
                          if (!is_search_dest) {
                      selected_item.id_azienda = item.id_anagrafica;
                      selezionaAzienda();
                    } else {
                      selected_item.id_azienda_dest = item.id_anagrafica;
                      selezionaAziendaDest();
                    }
                      ">
                      <v-icon color="primary">mdi-check</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Servizio {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_servizio", default_val: null },
      { nome: "id_tipo_servizio", default_val: null },
      { nome: "id_azienda", default_val: null },
      { nome: "data_richiesta", default_val: "" },
      { nome: "data_inizio", default_val: "" },
      { nome: "data_fine", default_val: "" },
      { nome: "localita_partenza", default_val: "" },
      { nome: "provincia_partenza", default_val: "" },
      { nome: "cap_partenza", default_val: null },
      { nome: "indirizzo_partenza", default_val: "" },
      { nome: "civico_partenza", default_val: null },
      { nome: "id_azienda_dest", default_val: null },
      { nome: "id_sede_dest_senza_deposito", default_val: "" },
      { nome: "localita_dest_senza_deposito", default_val: "" },
      { nome: "provincia_dest_senza_deposito", default_val: "" },
      { nome: "cap_dest_senza_deposito", default_val: null },
      { nome: "indirizzo_dest_senza_deposito", default_val: "" },
      { nome: "civico_dest_senza_deposito", default_val: null },
      { nome: "id_articolo", default_val: null },
      { nome: "id_listino", default_val: null },
      { nome: "localita_arrivo", default_val: "" },
      { nome: "provincia_arrivo", default_val: "" },
      { nome: "cap_arrivo", default_val: null },
      { nome: "indirizzo_arrivo", default_val: "" },
      { nome: "distanza", default_val: null },
      { nome: "tempo_percorrenza", default_val: null },
      { nome: "id_sede_arrivo", default_val: "" },
      { nome: "id_zona", default_val: "" },
      { nome: "riferimento", default_val: "" },
      { nome: "id_dashboard", default_val: -1 },
      { nome: "orario_preferibile", default_val: "" },
      { nome: "ora_inizio", default_val: "" },
      { nome: "ora_fine", default_val: "" },
      { nome: "attesa_carico", default_val: 0 },
      { nome: "attesa_carico_valore", default_val: 30 },
      { nome: "attesa_carico_um", default_val: 0 },
      { nome: "civico_arrivo", default_val: null },
      { nome: "referente", default_val: null },
      { nome: "cellulare", default_val: "" },
      { nome: "descrizione", default_val: "" },
      { nome: "id_tipo_formulario", default_val: "" },
      { nome: "id_causale_formulario", default_val: "" },
      { nome: "festivo_compreso", default_val: 0 },
      { nome: "sabato_compreso", default_val: 0 },
      { nome: "domenica_compreso", default_val: 0 },
      { nome: "tempo_setup_partenza", default_val: 30 },
      { nome: "tempo_setup_arrivo", default_val: 30 },
      { nome: "pianificato", default_val: 0 },
      { nome: "errori", default_val: {} },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}
export default {
  name: "QLGeneraleServizi",

  components: {
    SnackbarQV,
    Modules: () => import("../../../../components/TOOLS/Modules"),
  },

  props: {
    selected_item: Servizio,
    //items_azienda: Array,
  },

  data() {
    return {
      // Variabili d'appoggio
      overlay: false,
      mostra_colori_sel: false,
      selected_azienda: {},
      search_azienda: "",
      search_cod_univoco: "",
      is_cod_search: false,
      search_piva: "",

      selected_azienda_dest: {},
      search_azienda_dest: "",
      search_cod_univoco_dest: "",
      is_cod_search_dest: false,
      search_piva_dest: "",
      is_dest_senza_deposito: false,
      is_search_dest: false,

      // Filtri
      tipo_filter: "",
      azienda_filter: "",
      // Variabili tabella/crea/modifica/filtri
      data_table: true,
      create_edit_template: false,
      delete_dialog: false,
      dialog_search_aziende: false,

      // Array
      azienda_sedi: [],
      azienda_sedi_dest: [],
      items_regioni: [],
      dashboards: [],
      items_province: [],
      items_comuni: [],
      items_zona: [],
      items_tipo_formulario: [],
      items_causale_formulario: [],
      items_attesa_carico_um: [],
      items_azienda: [],
      items_fascia: [],
      headers_azienda: [
        {
          text: "",
          value: "seleziona",
          sortable: false,
          width: "120px",
        },
        { text: "Cod. Cliente", value: "codice_univoco" },
        { text: "Ragione sociale", value: "ragione_sociale" },
        { text: "P. IVA", value: "piva" },
        { text: "Indirizzo", value: "indirizzo" },
      ],
      // colori color-picker
      swatches: [
        ["#1976D2", "#93EB74"],
        ["#FFB7B2", "#FFDAC1"],
        ["#E2F0CB", "#B5EAD7"],
        ["#C7CEEA", "#000055"],
      ],
      swatches_text: [
        ["#000000", "#FFFFFF"],
        ["#FFFF00", "#FF0000"],
        ["#00FF00", "#005500"],
        ["#0000FF", "#000055"],
      ],
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() { },
    },
  },

  methods: {
    async GetDefault() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "DASHBOARD_LOGISTIC",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (this.selected_item.id_dashboard == null || this.selected_item.id_dashboard < 0) {
              this.selected_item.id_dashboard =
                res.data != null && res.data != ""
                  ? res.data[0].val_int
                  : null;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async GetDashboard() {
      let request = {
        controller: "graph",
        method: "POST",
        richiesta: {
          action: "getdashboard",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.dashboards = res.data.result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cambioData() {
      console.log("cambio data");
      this.selected_item.data_fine = this.selected_item.data_inizio;
    },
    controlloData() {
      console.log("cambio data");
      if (this.selected_item.data_fine < this.selected_item.data_inizio) {
        this.selected_item.data_fine = this.selected_item.data_inizio;
        this.$refs.SnackbarQV.print(
              "orange",
              "Non puoi selezionare una data precedente alla Data Inizio."
            );
      }
    },
    getAllineaAnagrafica(cod_cliente) {
      if (!cod_cliente) return;
      const richiesta = {
        controller: "wsecogreen",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "syncanagrafica",
          codice_univoco: cod_cliente,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200 || res.status == 204) {
            this.$refs.SnackbarQV.print(
              "success",
              "Anagrafica (cod. cliente: " +
              cod_cliente +
              ") allineata."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore: " + e);
        });
    },

    getAllineaSedi(is_dest) {
      let tmp_cod_univoco = is_dest
        ? this.search_cod_univoco_dest
        : this.search_cod_univoco;
      if (!tmp_cod_univoco) return;

      const richiesta = {
        controller: "wsecogreen",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "syncsedi",
          codice_univoco: tmp_cod_univoco,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200 || res.status == 204) {
            let record_aggiornati = res.data.record_aggiornati
              ? res.data.record_aggiornati
              : 0;
            this.$refs.SnackbarQV.print(
              "success",
              "Sedi allineate: " + record_aggiornati
            );

            // Aggiorna l'anagrafica corrente.
            if (is_dest) {
              this.is_cod_search_dest = true;
              this.goToAnagraficaDest("", "", tmp_cod_univoco);
              this.is_cod_search_dest = false;
            } else {
              this.is_cod_search = true;
              this.goToAnagrafica("", "", tmp_cod_univoco);
              this.is_cod_search = false;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print("error", "Errore: " + e);
        });
    },

    aggiornaItemsAutocomplete() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'EG_ZONA','TIPO_FORMULARIO'",
          filter: `validita = 1`,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.items_zona = res.data.EG_ZONA ? res.data.EG_ZONA : [];
          this.items_tipo_formulario = res.data.TIPO_FORMULARIO ? res.data.TIPO_FORMULARIO : [];
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });

      const causale_formulario = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "CAUSALE_FORMULARIO",
          filter: "validita = 1 && val_int1 = '" + this.selected_item.id_tipo_formulario + "'",
        },
      };

      if (this.selected_item.id_tipo_formulario)
        this.$store.dispatch("api", causale_formulario).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_causale_formulario = res.data ? res.data : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });

      const um_attesa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "UNITA_MISURA",
          filter: `validita = 1 && val_txt='H'`,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", um_attesa).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.items_attesa_carico_um = res.data ? res.data : [];
          console.log("items_attesa_carico_um ==>",this.items_attesa_carico_um);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },


    aggiornaItems(sede) {
      const getregioni = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getregioni",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api6", getregioni).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.items_regioni = res.data.result ? res.data.result : [];
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
      if (
        sede &&
        sede.id_regione != null &&
        typeof sede.id_regione == "number"
      ) {
        const getprovince = {
          controller: "logistic",
          method: "POST",
          richiesta: {
            token: localStorage.getItem("user_token"),
            action: "getprovince",
            id_regione: sede.id_regione,
          },
        };
        this.overlay = true;
        this.$store.dispatch("api6", getprovince).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_province = res.data.result ? res.data.result : [];
            this.$forceUpdate();
          } else {
            console.log("ERRORE");
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
      }
      if (
        sede &&
        sede.id_provincia != null &&
        typeof sede.id_provincia == "number"
      ) {
        const getcomuni = {
          controller: "logistic",
          method: "POST",
          richiesta: {
            token: localStorage.getItem("user_token"),
            action: "getcomuni",
            id_provincia: sede.id_provincia,
          },
        };
        this.overlay = true;
        this.$store.dispatch("api6", getcomuni).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_comuni = res.data.result ? res.data.result : [];
            this.$forceUpdate();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
      }

      this.overlay = false;
    },
    swatchesDefault() {
      let b = false;
      this.swatches.forEach((s) => {
        if (s.includes(this.selected_item.colore_sfondo.hex)) b = true;
      });
      if (b === false) this.selected_item.colore_sfondo.hex = "#1976D2";
      b = false;
      this.swatches_text.forEach((s) => {
        if (s.includes(this.selected_item.colore_testo.hex)) b = true;
      });
      if (b === false) this.selected_item.colore_testo.hex = "#000000";
    },
    message(message) {
      this.$refs.SnackbarQV.print("orange", message);
    },

    aggiornaCampiDest() {
      const sede = this.azienda_sedi_dest.find(
        (s) =>
          s.id_anagrafica_sede ===
          this.selected_item.id_sede_dest_senza_deposito
      );
      this.selected_item.indirizzo_dest_senza_deposito = sede.indirizzo;
      this.selected_item.cap_dest_senza_deposito = sede.cap;
      this.selected_item.civico_dest_senza_deposito = sede.civico;
      if (sede.id_comune && sede.id_provincia && sede.id_regione) {
        const getprovince = {
          controller: "logistic",
          method: "POST",
          richiesta: {
            token: localStorage.getItem("user_token"),
            action: "getprovince",
            id_regione: sede.id_regione,
          },
        };
        this.overlay = true;
        this.$store.dispatch("api6", getprovince).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.selected_item.provincia_dest_senza_deposito =
              res.data.result.filter(
                (p) => p.id_provincia == sede.id_provincia
              )[0].sigla;
          } else {
            // console.log("ERRORE");
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
        const getcomuni = {
          controller: "logistic",
          method: "POST",
          richiesta: {
            token: localStorage.getItem("user_token"),
            action: "getcomuni",
            id_provincia: sede.id_provincia,
          },
        };
        this.overlay = true;
        this.$store.dispatch("api6", getcomuni).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.selected_item.localita_dest_senza_deposito =
              res.data.result.filter(
                (c) => c.id_comune == sede.id_comune
              )[0].comune;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
      }
    },

    aggiornaCampi() {
      this.selected_item.distanza = null;
      this.selected_item.tempo_percorrenza = null;
      const sede = this.azienda_sedi.find(
        (s) =>
          s.id_anagrafica_sede === this.selected_item.id_sede_arrivo
      );
      this.selected_item.indirizzo_arrivo = sede.indirizzo;
      this.selected_item.cap_arrivo = sede.cap;
      this.selected_item.civico_arrivo = sede.civico;
      if (sede.id_comune && sede.id_provincia && sede.id_regione) {
        const getprovince = {
          controller: "logistic",
          method: "POST",
          richiesta: {
            token: localStorage.getItem("user_token"),
            action: "getprovince",
            id_regione: sede.id_regione,
          },
        };
        this.overlay = true;
        this.$store.dispatch("api6", getprovince).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.selected_item.provincia_arrivo = res.data.result.filter(
              (p) => p.id_provincia == sede.id_provincia
            )[0].sigla;
          } else {
            // console.log("ERRORE");
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
        const getcomuni = {
          controller: "logistic",
          method: "POST",
          richiesta: {
            token: localStorage.getItem("user_token"),
            action: "getcomuni",
            id_provincia: sede.id_provincia,
          },
        };
        this.overlay = true;
        this.$store.dispatch("api6", getcomuni).then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.selected_item.localita_arrivo = res.data.result.filter(
              (c) => c.id_comune == sede.id_comune
            )[0].comune;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
      }
    },

    goToAnagraficaDest(
      filtro_rag_soc = null,
      filtro_piva = null,
      filtro_cod_univoco = null
    ) {
      this.is_search_dest = true;
      if (!this.is_cod_search_dest) {
        if (
          (filtro_rag_soc.length < 3 && !filtro_piva) ||
          (!filtro_rag_soc && filtro_piva.length < 3)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Digita almeno 3 caratteri per la ricerca."
          );
          return;
        }
      } else {
        if (!filtro_cod_univoco) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Inserisci un codice per la ricerca."
          );
          this.is_cod_search_dest = false;
          return;
        }
      }

      const getragionesociale = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziende",
          ragione_sociale: filtro_rag_soc,
          piva: filtro_piva,
          codice_univoco: filtro_cod_univoco,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api6", getragionesociale)
        .then((res) => {
          this.overlay = false;

          if (res.data.result.length > 1) {
            this.items_azienda = res.data.result;
            /*let headers = res.data.result.t_header;
this.ragioneSociale = [];
this.ragioneSociale.push({ text: null, value: null, align: "start" });
headers.forEach((header) => {
if (header.visible == 1) {
  this.ragioneSociale.push(header);
}
});*/
            this.dialog_search_aziende = true;
          }

          if (res.data.result.length === 0) {
            if (filtro_rag_soc)
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate ragioni sociali con questo nome."
              );
            else if (filtro_piva)
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate ragioni sociali con questa partita IVA."
              );
            else if (filtro_cod_univoco)
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate ragioni sociali con questo codice."
              );
          }

          if (res.data.result.length === 1) {
            this.items_azienda = res.data.result;
            this.selected_item.id_azienda_dest =
              res.data.result[0].id_anagrafica;

            this.selezionaAziendaDest();
          }
        })
        .catch((e) => {
          this.$refs.SnackbarQV.print("error", "Errore: " + e);
          this.overlay = false;
        });
    },

    goToAnagrafica(
      filtro_rag_soc = null,
      filtro_piva = null,
      filtro_cod_univoco = null
    ) {
      this.is_search_dest = false;
      if (!this.is_cod_search) {
        if (
          (filtro_rag_soc.length < 3 && !filtro_piva) ||
          (!filtro_rag_soc && filtro_piva.length < 3)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Digita almeno 3 caratteri per la ricerca."
          );
          return;
        }
      } else {
        if (!filtro_cod_univoco) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Inserisci un codice per la ricerca."
          );
          this.is_cod_search = false;
          return;
        }
      }

      const getragionesociale = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziende",
          ragione_sociale: filtro_rag_soc,
          piva: filtro_piva,
          codice_univoco: filtro_cod_univoco,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api6", getragionesociale)
        .then((res) => {
          this.overlay = false;

          if (res.data.result.length > 1) {
            this.items_azienda = res.data.result;
            /*let headers = res.data.result.t_header;
this.ragioneSociale = [];
this.ragioneSociale.push({ text: null, value: null, align: "start" });
headers.forEach((header) => {
if (header.visible == 1) {
  this.ragioneSociale.push(header);
}
});*/
            this.dialog_search_aziende = true;
          }

          if (res.data.result.length === 0) {
            if (filtro_rag_soc)
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate ragioni sociali con questo nome."
              );
            else if (filtro_piva)
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate ragioni sociali con questa partita IVA."
              );
            else if (filtro_cod_univoco)
              this.$refs.SnackbarQV.print(
                "orange",
                "Non sono state trovate ragioni sociali con questo codice."
              );
          }

          if (res.data.result.length === 1) {
            this.items_azienda = res.data.result;
            this.selected_item.id_azienda =
              res.data.result[0].id_anagrafica;

            this.selezionaAzienda();
          }
        })
        .catch((e) => {
          this.$refs.SnackbarQV.print("error", "Errore: " + e);
          this.overlay = false;
        });
    },

    async getAziende(filtro_rag_soc = null, id_azienda = null) {
      if (!id_azienda) {
        if (!filtro_rag_soc) return;
        if (filtro_rag_soc.length < 3) {
          this.items_azienda = [];
          return;
        }
      }

      const getragionesociale = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziende",
          ragione_sociale: filtro_rag_soc,
          id_anagrafica: id_azienda,
        },
      };
      this.overlay = true;
      return this.$store
        .dispatch("api6", getragionesociale)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_azienda = res.data.result ? res.data.result.reverse() : [];
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        });
    },
    getFasciaOraria() {
      this.overlay = true;
      const getragionesociale = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getfasceorarie",
        },
      };

      return this.$store
        .dispatch("api6", getragionesociale)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_fascia = res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
    },

    selezionaAziendaDest() {
      this.azienda_sedi_dest = null;
      this.selected_azienda_dest = this.items_azienda.find(
        (a) => a.id_anagrafica === this.selected_item.id_azienda_dest
      );

      if (this.selected_item.id_azienda_dest != null) {
        this.search_azienda_dest =
          this.selected_azienda_dest.ragione_sociale;
        this.search_cod_univoco_dest =
          this.selected_azienda_dest.codice_univoco;
        this.search_piva_dest = this.selected_azienda_dest.piva;
        this.selected_item.referente =
          this.selected_azienda_dest.telefono;
        if (this.selected_azienda_dest.sedi) {
          this.azienda_sedi_dest = this.selected_azienda_dest.sedi;

          if (
            this.azienda_sedi_dest != null &&
            this.azienda_sedi_dest.find((s) => s.predefinito === 1)
          ) {
            this.selected_item.id_sede_dest_senza_deposito =
              this.azienda_sedi.find(
                (s) => s.predefinito === 1
              ).id_anagrafica_sede;
            this.aggiornaCampiDest();
          } else
            this.selected_item.id_sede_dest_senza_deposito = null;
        }

        this.$emit("aggiornaTipoPagamento");

      } else {
        this.selected_azienda_dest = {};
      }
      this.dialog_search_aziende = false;
    },

    selezionaAzienda() {
      this.azienda_sedi = null;
      this.selected_azienda = this.items_azienda.find(
        (a) => a.id_anagrafica === this.selected_item.id_azienda
      );

      if (this.selected_item.id_azienda != null) {
        this.search_azienda = this.selected_azienda.ragione_sociale;
        this.search_cod_univoco = this.selected_azienda.codice_univoco;
        this.search_piva = this.selected_azienda.piva ? this.selected_azienda.piva : this.selected_azienda.codice;
        this.selected_item.referente = this.selected_azienda.telefono;
        if (this.selected_azienda.sedi) {
          this.azienda_sedi = this.selected_azienda.sedi;

          if (
            this.azienda_sedi != null &&
            this.azienda_sedi.find((s) => s.predefinito === 1)
          ) {
            this.selected_item.id_sede_arrivo =
              this.azienda_sedi.find(
                (s) => s.predefinito === 1
              ).id_anagrafica_sede;
            this.aggiornaCampi();
          } else this.selected_item.id_sede_arrivo = null;
        }

        this.$emit("aggiornaTipoPagamento");

      } else {
        this.selected_azienda = {};
      }
      this.dialog_search_aziende = false;
    },
  },

  created() { },

  async mounted() {
    this.getFasciaOraria()
    this.GetDashboard();
    this.GetDefault();
    this.aggiornaItemsAutocomplete();
    this.swatchesDefault();

    if (this.selected_item.id_azienda != null)
      await this.getAziende(null, this.selected_item.id_azienda);

    if (
      this.selected_item.id_azienda != null &&
      this.items_azienda.filter(
        (a) => a.id_anagrafica === this.selected_item.id_azienda
      ).length > 0
    ) {
      this.azienda_sedi = this.items_azienda.find(
        (a) => a.id_anagrafica === this.selected_item.id_azienda
      ).sedi;
      this.selected_azienda = this.items_azienda.find(
        (a) => a.id_anagrafica === this.selected_item.id_azienda
      );
      this.search_azienda = this.selected_azienda.ragione_sociale;
      this.search_cod_univoco = this.selected_azienda.codice_univoco;
      this.search_piva = this.selected_azienda.piva ? this.selected_azienda.piva : this.selected_azienda.codice;

      if (
        this.selected_item.id_sede_arrivo == null &&
        this.selected_item.id_azienda != null
      )
        this.selezionaAzienda();
      else this.$emit("aggiornaTipoPagamento");
    }

    if (this.selected_item.id_azienda_dest != null) {
      await this.getAziende(null, this.selected_item.id_azienda_dest);
    }

    if (
      this.selected_item.id_azienda_dest ||
      this.selected_item.localita_dest_senza_deposito ||
      this.selected_item.cap_dest_senza_deposito ||
      this.selected_item.civico_dest_senza_deposito ||
      this.selected_item.id_sede_dest_senza_deposito ||
      this.selected_item.provincia_dest_senza_deposito ||
      this.selected_item.indirizzo_dest_senza_deposito
    )
      this.is_dest_senza_deposito = true;

    if (
      this.selected_item.id_azienda_dest != null &&
      this.items_azienda.filter(
        (a) => a.id_anagrafica === this.selected_item.id_azienda_dest
      ).length > 0
    ) {
      this.azienda_sedi_dest = this.items_azienda.find(
        (a) => a.id_anagrafica === this.selected_item.id_azienda_dest
      ).sedi;
      this.selected_azienda_dest = this.items_azienda.find(
        (a) => a.id_anagrafica === this.selected_item.id_azienda_dest
      );
      this.search_azienda_dest =
        this.selected_azienda_dest.ragione_sociale;
      this.search_cod_univoco_dest =
        this.selected_azienda_dest.codice_univoco;
      this.search_piva_dest = this.selected_azienda_dest.piva;

      if (
        this.selected_item.id_sede_dest_senza_deposito == null &&
        this.selected_item.id_azienda_dest != null
      )
        this.selezionaAziendaDest();
    }
  },
};
</script>